import { RestrictAccessRequest, individualsService } from '@aslanpay/portal-common-lib';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

const useRestrictAccess = ({
  onSuccess,
  onError,
}: UseMutationOptions<unknown, Error, RestrictAccessRequest>) => {
  return useMutation<unknown, Error, RestrictAccessRequest>(
    ({ id }: RestrictAccessRequest) => individualsService.restrictAccess({ id }),
    {
      onSuccess,
      onError,
    }
  );
};

export default useRestrictAccess;
